<template>
  <div>
    <span>

      <button v-on:click="detayaGit()" style="border: none; background: none; margin-right: 5px">
        <Icon icon="akar-icons:search" color="#7367f0" width="15" height="15" />
      </button>
    </span>
  </div>
</template>
<script>
import { Icon } from "@iconify/vue2";
export default {
  components: { Icon },
  methods: {
    detayaGit() {
      this.$root.$emit("categoryPick", this.params);
    },
  },
};
</script>